<template>
    <div key="checkoffAttachment">
        <b-card
            v-if="isVisible"
            :img-src="model.url"
            img-alt="Image"
            img-top
            tag="article"
        >
            <b-card-title class="justify-center">{{
                `Image ${currentIndex + 1} of ${attachments.length}`
            }}</b-card-title>
            <b-container>
                <b-row align-h="between">
                    <b-col cols="2">
                        <b-button
                            :disabled="currentIndex <= 0"
                            block
                            variant="info"
                            @click="--currentIndex"
                        >
                            <b-icon icon="arrow-left"></b-icon
                        ></b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button
                            block
                            variant="warning"
                            @click="currentIndex = -1"
                            >Cancel</b-button
                        >
                    </b-col>
                    <b-col cols="2" v-if="!checkoff.completed">
                        <b-button
                            block
                            variant="danger"
                            v-if="hPermissionDelete"
                            @click="deleteAttachment(model.id)"
                            >Delete</b-button
                        >
                    </b-col>
                    <b-col cols="2">
                        <b-button
                            :disabled="currentIndex >= attachments.length - 1"
                            block
                            variant="info"
                            @click="++currentIndex"
                        >
                            <b-icon icon="arrow-right"></b-icon
                        ></b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-card>
        <div v-else>
            <b-row v-if="!checkoff.completed">
                <b-col cols="12">
                    <b-form-file
                        id="uploadCheckoffData"
                        @change="uploadCheckoffFile"
                    ></b-form-file>
                </b-col>
            </b-row>
            <b-container fluid class="p-4 mt-4 bg-dark">
                <b-row>
                    <b-col
                        v-for="(item, index) in attachments"
                        :key="index"
                        md="3"
                        class="mb-2"
                    >
                        <b-button @click="currentIndex = index">
                            <b-img
                                thumbnail
                                fluid
                                :src="item.url"
                                alt="Image 1"
                            ></b-img>
                        </b-button>
                    </b-col>
                    <b-col v-if="!attachments.length">
                        <h4 class="text-white">No Attachments Submitted</h4>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-ViewCheckoffAttachments',
    mixins: [popupMixins, permissionsMixins],
    props: ['order_id', 'order_checkoff_id'],
    data() {
        return {
            submitting: false,
            model: null,

            currentIndex: -1,
        }
    },
    computed: {
        isVisible() {
            return this.currentIndex >= 0
        },
        attachments() {
            const attachments = this.checkoff.checkoff_attachments
            console.log(attachments)
            return attachments
        },

        checkoff() {
            return this.order.checkoffs.find(
                x => x.id === this.order_checkoff_id
            )
        },

        order() {
            return this.$store.state.orders.item
        },
    },
    watch: {
        currentIndex: function (index) {
            if (index >= 0) {
                const item = this.attachments[index]
                console.log(this.attachments)
                console.log('item', item)
                this.model = {}
                for (const key in item) {
                    this.$set(this.model, key, item[key])
                }
            }
        },
    },
    mounted() {
        this.$store.dispatch('js_report/fetchCredentials')
    },
    methods: {
        async uploadCheckoffFile(event) {
            console.log('uploadCheckoff event', event)

            try {
                console.log(event.target.files)
                // let chkPnt = 1

                const { key, name } = await this.$store.dispatch(
                    's3files/s3upload',
                    event.target.files
                )

                const { order_id: id, order_checkoff_id } = this

                const url = `${this.$OMSStorageUrl}/${key}`
                console.log({ key, name, url })
                console.log({
                    id,
                    order_checkoff_id,
                    url,
                })
                //   if (chkPnt === 1) throw new Error('Aborted')
                await this.$store.dispatch('orders/addCheckoffAttachment', {
                    id,
                    order_checkoff_id,
                    url,
                })

                this.genericToast(
                    'Activity Review',
                    'Updated',
                    'success',
                    `Checkoff attachment successfully added`
                )

                this.$emit('attachment-added', order_checkoff_id)
            } catch (error) {
                console.error('addAttachement', error)
                this.doToast('Error!', 'Error Adding Attachment!', 'danger')
            } finally {
                this.submitting = false
            }
        },

        deleteAttachment(attachment_id) {
            const title = 'Delete Attachment?'
            const message = `Are you sure you want to delete this attachment?`
            this.confirmMessage(title, message).then(result => {
                if (!result) return
                this.submitting = true
                const { order_id: id, order_checkoff_id } = this
                this.$store
                    .dispatch('orders/deleteCheckoffAttachment', {
                        id,
                        order_checkoff_id,
                        attachment_id,
                    })
                    .then(() => {
                        this.genericToast(
                            'Checkoff Attachment',
                            'Deleted',
                            'success',
                            `Checkoff attachment successfully deleted`
                        )

                        this.currentIndex = -1
                    })
                    .catch(error => {
                        console.error(error)
                        this.doToast(
                            'Error!',
                            'Error Deleting Attachment!',
                            'danger'
                        )
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
    },
}
</script>

<style lang="scss" scoped></style>
